/**
 * Célula de CSV segura para planilha (rodada crm1, SEG-B1; a regra de `modules/relatorios/src/csv.ts`): texto que começa com
 * `=`, `+`, `-`, `@` ou tab ganha um apóstrofo na frente (o Excel não executa como fórmula), salvo número negativo; aspas
 * quando há separador, aspas ou quebra de linha.
 */
export function celulaCsv(v: string | number | null | undefined): string {
  let s = v === null || v === undefined ? '' : String(v);
  if (/^[=+\-@\t]/.test(s) && !/^-\d+([.,]\d+)?$/.test(s)) s = `'${s}`;
  return /[";\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
